import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { getText } from './utils';
// @ts-ignore

function includes(test, search) {
  return getText(test).toLowerCase().includes(search);
}
export default (function (options, childrenKey, labelKey, valueKey, searchWord, filterOption) {
  return React.useMemo(function () {
    if (!searchWord || filterOption === false) {
      return options;
    }
    var filteredOptions = [];
    var customizeFilter = typeof filterOption === 'function';
    var upperSearch = searchWord.toString().toLowerCase();
    var filterFunc = customizeFilter ? filterOption : function (_, option) {
      return includes(option, upperSearch);
    };
    options.filter(function (option) {
      return option[valueKey] !== 'appkit4-select-all-key';
    }).forEach(function (item) {
      if (item[childrenKey]) {
        var matchGroup = filterFunc(searchWord, item[labelKey]);
        if (matchGroup) {
          filteredOptions.push(item);
        } else {
          var subOptions = item[childrenKey].filter(function (subItem) {
            return filterFunc(searchWord, getText(subItem[labelKey]));
          });
          if (subOptions.length) {
            var _extends2;
            filteredOptions.push(_extends({}, item, (_extends2 = {}, _extends2[childrenKey] = subOptions, _extends2)));
          }
        }
        return;
      }
      if (filterFunc(searchWord, getText(item[labelKey]))) {
        filteredOptions.push(item);
      }
    });
    return filteredOptions;
  }, [options, searchWord, filterOption]);
});